<template>
  <div class="loginStatus-box-outer">
    <div v-if="!user.avatar" class="login">
      <a class="text" @click="login('login')"> 登录 </a>
      <a class="text register" @click="login('register')">
        <el-button>注册</el-button>
      </a>
    </div>
    <div class="avatar-box" v-else>
      <el-popover placement="bottom-end" :width="170" trigger="click">
        <div class="info-wrapper">
          <div class="info-top">
            <p class="text">{{ user.nickname }}</p>
            <p class="text">
              {{ newphone }}
            </p>
          </div>
          <div class="info-bar">
            <sideBar />
          </div>
          <div class="info-loginOut">
            <el-button type="text" @click="toMineSubject">退出登录</el-button>
          </div>
        </div>
        <template #reference>
          <el-avatar class="e-avatar" :size="50" :src="user.avatar"></el-avatar>
        </template>
      </el-popover>
    </div>
    <div class="vip" v-if="user.is_vip == '1'">
      <img src="@/assets/images/common/vip.png" width="50" />
    </div>
  </div>
  <login-dialog :isShowDialog="isShowDialog" :status="status" />
</template>
      
<script lang="ts">
import { onBeforeMount, defineComponent, ref, provide } from "vue";
import { Router, useRouter } from "vue-router";
import sideBar from "@/components/mine/sideBar.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import loginDialog from "@/components/loginDialog/index.vue";
export default defineComponent({
  components: {
    sideBar,
    loginDialog,
  },
  setup() {
    const user = ref<any>({});
    const newphone = ref("");
    const status = ref("login");

    onBeforeMount(() => {
      user.value = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo") as string)
        : {};
      if (user.value.mobile) {
        const phone = user.value.mobile.toString();
        newphone.value = phone.replace(phone.substr(3, 4), "****");
      }
    });

    const router = useRouter();
    const toMineSubject = (): void => {
      ElMessageBox.confirm("确定要退出登录么？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "outLoginBox",
      })
        .then(() => {
          localStorage.removeItem("authorization");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("expirationTime");
          ElMessage({
            type: "success",
            message: "退出成功！",
          });
          if (
            location.origin == "https://pay2.diancang.site" ||
            location.origin == "https://zhishiquan.online"
          ) {
            location.href = "/official-web/";
          } else {
            location.href = "/";
          }
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "取消退出！",
          });
        });
    };
    const isShowDialog = ref(false);
    const login = (val: string) => {
      isShowDialog.value = false;
      setTimeout(() => {
        isShowDialog.value = true;
        status.value = val;
      }, 200);
    };
    return {
      newphone,
      toMineSubject,
      user,
      login,
      isShowDialog,
      status,
    };
  },
});
</script>
<style  lang="scss">
.outLoginBox {
  width: 426px;
  height: 210px;
  .el-message-box__message {
    text-align: center;
    margin: 30px 0;
  }
  .el-message-box__headerbtn {
    color: #979797;
    font-size: 24px;
    &:hover .el-message-box__close{
      color: #979797;
    }
  }
  .el-message-box__btns {
    justify-content: space-around;
    padding: 0 40px;
    box-sizing: border-box;
    .el-button {
      width: 128px;
      height: 40px;
      font-size: 16px;
      &:nth-child(1),
      &:nth-child(1):hover {
        border-color: #bbbbbb;
        background: #ffffff;
        color: #676767;
      }
      &:nth-child(2),
      &:nth-child(2):hover {
        border-color: #ffca28;
        background: #ffca28;
        color: #000000;
      }
    }
  }
}
.e-avatar {
  // position: relative;
  // top: -8px;
}
.el-popper.is-light {
  padding: 0 !important;
}
.info-wrapper {
  .info-top {
    padding: 15px 20px;
    border-bottom: 1px solid #eeeeee;
    .text {
      font-size: 14px;
      color: #999999;
      line-height: 20px;
    }
  }
  .info-bar {
    .sideBar-index {
      padding: 0;
      .el-menu-item {
        padding: 0 20px !important;
        text-align: left;
        display: block;
        line-height: 45px;
        height: 45px;
        position: relative;
        font-size: 14px;
        color: #333;
      }
    }
  }
  .info-loginOut {
    border-top: 1px solid #eeeeee;
    line-height: 57px;
    padding-left: 15px;
    .el-button--default {
      font-size: 14px;
      font-weight: 400;
      color: #222;
      background: none;
    }
  }
}
.info-bar .sideBar-index .el-menu-item.is-active::before {
  display: none !important;
}
.loginStatus-box-outer {
  .el-dialog {
    width: 764px;
  }
  .el-dialog--center .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
}
</style>
<style  lang="scss" scoped>
.loginStatus-box-outer {
  height: 72px;
  text-align: center;
  line-height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .login {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #fafafa;
    text-decoration: none;
    margin-left: 30px;
    button:hover,
    button:active,
    button:focus {
      background: rgba(44, 46, 58, 0.52);
      color: #ffcc00;
    }
  }
  .avatar-box {
    display: flex;
    align-items: center;
  }
}
.el-button--default {
  width: 72px;
  height: 40px;
  background: rgba(44, 46, 58, 0.52);
  border-radius: 4px;
  text-align: center;
  border: none;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #ffcc00;
}
.vip {
  position: absolute;
  right: 59px;
  top: 27px;
}
</style>